import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import {
    MainScreen,
    OverContentLoadableBlock,
    PageFrame,
    ShowComponent,
    useNavigate,
} from '@alfa-retail-react/components';

import { SmsSignSkeleton } from 'app/component/page/skeletons';
import { unauthorizedExceptionHandlerOnLoadData } from 'app/logic/pages/error/unauthorizedExceptionHandler';
import { exceptionLogger } from 'app/logic/pages/error/exceptionLogger';
import { useApplicationContext } from 'app/store/сontext/ApplicationContext';
import { useNotificationContext } from 'app/store/сontext/NotificationContextProvider';
import { defaultExceptionHandler } from 'app/logic/pages/error/defaultExceptionHandler';
import { networkExceptionHandlerOnLoadData } from 'app/logic/pages/error/networkExceptionHandler';
import { orderRejectedExceptionHandler } from 'app/logic/pages/error/orderRejectedExceptionHandler';
import { SmsSigningForm } from 'app/logic/pages/sign/SmsSigningForm';
import { SmsSignFormStore } from 'app/logic/pages/sign/SmsSignFormStore';
import { useAnalytics } from 'app/analytics/useAnalytics';
import { useI18nContext } from 'app/store/сontext/I18nContext';

const PAGE_NAME = 'SignPage';

export const SmsSignPage = observer(() => {
    const navigate = useNavigate();
    const notification = useNotificationContext();
    const applicationContext = useApplicationContext();
    const i18nContext = useI18nContext();
    const analytics = useAnalytics(
        applicationContext.productCode,
        PAGE_NAME,
        false,
    );

    const orderId = sessionStorage.getItem('orderId');
    const formStore = useRef<SmsSignFormStore>(
        new SmsSignFormStore(orderId),
    ).current;
    const { loadStateStore } = formStore;

    useEffect(() => {
        analytics.pageDisplayed();

        formStore
            .initialize()
            .catch(exceptionLogger(PAGE_NAME, 'formStore.initialize'))
            .catch(
                unauthorizedExceptionHandlerOnLoadData({
                    navigate,
                    phoneNumber: applicationContext.phoneNumber,
                }),
            )
            .catch(
                orderRejectedExceptionHandler(
                    navigate,
                    analytics,
                    i18nContext.t,
                ),
            )
            .catch(networkExceptionHandlerOnLoadData({ navigate }))
            .catch(defaultExceptionHandler(notification, analytics));
    }, []);

    const backAction = () => {
        analytics.back();
        navigate(-1);
    };

    return (
        <OverContentLoadableBlock show={formStore.actionStateStore.isLoading}>
            <PageFrame
                rightAddonLogo={applicationContext.additionalLogo}
                className={'smsSignPage'}
                canGoPreviousPage
                backAction={backAction}
                displayFooter
            >
                <MainScreen>
                    <MainScreen.Header title={'Подписание документов'} />
                    <MainScreen.ContentBar>
                        <ShowComponent
                            condition={loadStateStore.isLoaded}
                            alternative={<SmsSignSkeleton />}
                        >
                            <SmsSigningForm
                                formStore={formStore}
                                analytics={analytics}
                            />
                        </ShowComponent>
                    </MainScreen.ContentBar>
                </MainScreen>
            </PageFrame>
        </OverContentLoadableBlock>
    );
});
